
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("jyeNt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getThemeOverrideFromQueryParameters", () => $b90ed86e8896ee31$export$169aec46c88e9cc8);
$parcel$export(module.exports, "default", () => $b90ed86e8896ee31$export$2e2bcd8739ae039);

var $cEiXz = parcelRequire("cEiXz");
var $esDSO = parcelRequire("esDSO");

var $b9op4 = parcelRequire("b9op4");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $dCm1o = parcelRequire("dCm1o");

var $Y0b1l = parcelRequire("Y0b1l");

var $gEdc8 = parcelRequire("gEdc8");
const $b90ed86e8896ee31$export$169aec46c88e9cc8 = ({ query: query })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (query?.themeMode && (0, $b9op4.ThemeOptions).includes(query.themeMode)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return query.themeMode;
    return undefined;
};
const $b90ed86e8896ee31$var$getResourceReturns = async (theme)=>{
    let typographyTheme;
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        typographyTheme = 'typography-modernized';
        if ((0, $4R6GH.fg)('platform-dst-jira-web-fonts')) typographyTheme = 'typography-refreshed';
    }
    const attrs = (0, $cEiXz.default)({
        colorMode: theme,
        typography: typographyTheme
    });
    const styles = await (0, $esDSO.default)({
        colorMode: theme,
        typography: typographyTheme
    });
    (0, $gEdc8.loadThemeTokens)(theme);
    return {
        theme: theme,
        attrs: attrs,
        styles: styles
    };
};
async function $b90ed86e8896ee31$export$2e2bcd8739ae039(context) {
    try {
        const theme = $b90ed86e8896ee31$export$169aec46c88e9cc8(context) || await (0, $Y0b1l.getThemePreference)();
        return await $b90ed86e8896ee31$var$getResourceReturns(theme || (0, $b9op4.DEFAULT_THEME));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.themePreferenceResource', 'themePreferenceResource', err);
        return {};
    }
}

});
parcelRegister("esDSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f5ba5fd47e0b8b$export$2e2bcd8739ae039);

var $fHpHg = parcelRequire("fHpHg");

var $g0l9Y = parcelRequire("g0l9Y");

var $9pyiD = parcelRequire("9pyiD");

var $9OnAz = parcelRequire("9OnAz");

var $iiK23 = parcelRequire("iiK23");

/**
 * Takes an object containing theme preferences, and returns an array of objects for use in applying styles to the document head.
 * Only supplies the color themes necessary for initial render, based on the current themeState. I.e. if in light mode, dark mode themes are not returned.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns A Promise of an object array, containing theme IDs, data-attributes to attach to the theme, and the theme CSS.
 * If an error is encountered while loading themes, the themes array will be empty.
 */ const $17f5ba5fd47e0b8b$var$getThemeStyles = async (preferences)=>{
    let themePreferences;
    let themeOverridePreferences = [];
    if (preferences === 'all') {
        themePreferences = (0, $g0l9Y.themeIdsWithOverrides);
        // CLEANUP: Remove
        if (!(0, $fHpHg.fg)('platform_increased-contrast-themes')) themePreferences = themePreferences.filter((n)=>n !== 'light-increased-contrast' && n !== 'dark-increased-contrast');
        themePreferences = themePreferences.filter((n)=>n !== 'light-brand-refresh' && n !== 'dark-brand-refresh');
    } else {
        const themeState = {
            colorMode: preferences?.colorMode || (0, $g0l9Y.themeStateDefaults)['colorMode'],
            contrastMode: preferences?.contrastMode || (0, $g0l9Y.themeStateDefaults)['contrastMode'],
            dark: preferences?.dark || (0, $g0l9Y.themeStateDefaults)['dark'],
            light: preferences?.light || (0, $g0l9Y.themeStateDefaults)['light'],
            shape: preferences?.shape || (0, $g0l9Y.themeStateDefaults)['shape'],
            spacing: preferences?.spacing || (0, $g0l9Y.themeStateDefaults)['spacing'],
            typography: preferences?.typography || (0, $g0l9Y.themeStateDefaults)['typography']()
        };
        themePreferences = (0, $9OnAz.getThemePreferences)(themeState);
        themeOverridePreferences = (0, $9OnAz.getThemeOverridePreferences)(themeState);
    }
    const results = await Promise.all([
        ...[
            ...themePreferences,
            ...themeOverridePreferences
        ].map(async (themeId)=>{
            try {
                const css = await (0, $iiK23.loadThemeCss)(themeId);
                return {
                    id: themeId,
                    attrs: {
                        'data-theme': themeId
                    },
                    css: css
                };
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
        }),
        // Add custom themes if they're present
        (async ()=>{
            if (preferences !== 'all' && preferences?.UNSAFE_themeOptions && (0, $9pyiD.isValidBrandHex)(preferences?.UNSAFE_themeOptions?.brandColor)) try {
                const { getCustomThemeStyles: getCustomThemeStyles } = await (parcelRequire("73Bsz"));
                const customThemeStyles = await getCustomThemeStyles({
                    colorMode: preferences?.colorMode || (0, $g0l9Y.themeStateDefaults)['colorMode'],
                    UNSAFE_themeOptions: preferences?.UNSAFE_themeOptions
                });
                return customThemeStyles;
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
        })()
    ]);
    return results.flat().filter((theme)=>theme !== undefined);
};
var $17f5ba5fd47e0b8b$export$2e2bcd8739ae039 = $17f5ba5fd47e0b8b$var$getThemeStyles;

});
parcelRegister("73Bsz", function(module, exports) {

let $5235def563a82061$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5235def563a82061$var$load("27oU7").then(()=>parcelRequire('guTYc'));

});


parcelRegister("gEdc8", function(module, exports) {

$parcel$export(module.exports, "loadThemeTokens", () => $18a391a234abcb46$export$de79e1eb6941ecb0);

var $4VEQo = parcelRequire("4VEQo");
const $18a391a234abcb46$export$de79e1eb6941ecb0 = async (theme)=>{
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if ([
        'light',
        'dark',
        'auto'
    ].includes(theme)) await (0, $4VEQo.default)({
        colorMode: theme
    });
};

});



//# sourceMappingURL=async-router-resources-theme-preference.da59955f.js.map
